import {makeStyles} from '@material-ui/core/styles'
import LocationTab from '../../../components/3modules/AccountImport/LocationTab'
import {useEffect, useState} from 'react'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import {useNavigate, useParams} from 'react-router-dom'
import Paper from '@mui/material/Paper'

const ApproveClientForm = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const id = useParams().id
    const [selectedClient, setSelectedClient] = useState(null)

    const onCancel = () => {
        navigate(`/adminDashboard`)
    }

    const onNext = () => {
        navigate(`/approveLocation/location/${id}`)
    }


    useEffect(()=>{
        const selectedClientFromStorage = getItemFromSessionStorage('selectedClient')
        if(selectedClientFromStorage){
            setSelectedClient(selectedClientFromStorage)
        }
    }, [])

    return (
        <Paper className={classes.root}>
            <LocationTab selectedClient={selectedClient} onNextLocation={onNext} onCancel={onCancel} disabled
                         importType={'Add one location'} />
        </Paper>
    )
}

export default ApproveClientForm

const useStyles = makeStyles({
    root: {
        margin: '20px',
        marginLeft: '80px',
        padding: '20px',
        width: '100%'
    }
})
